<script>
  import * as yup from "yup";
  import { createEventDispatcher, onMount } from "svelte";
  import { account, appSession, appConstants } from "../stores/app.js";
  import MyModal from "../components/MyModal.svelte";
  import { navigate } from "svelte-routing";
  import RestActions from "../components/RestActions.svelte";

  export let hash = null;
  let busy = false;
  const dispatch = createEventDispatcher();
  let restActions = null;
  
  let myModal;

  let form = {
    dirty: false,
    valid: true,
    submitted: false,

    data: {
      password: "",
      repeatpassword: ""
    },

    schema: yup.object().shape({
      password: yup
        .string()
        .test(
          "password",
          "8 characters minimum including one number & uppercase letter",
          value => {
            return ValidPassword(value);
          }
        )
        .required({ message: "Required" }),
      repeatpassword: yup
        .string()
        .test("repeatpassword", "Doesn't match", value => {
          return value === form.data.password;
        })
        .required({ message: "Required" })
    }),
    errors: null
  };

  onMount(() => {
    M.updateTextFields();
  });

  function ValidateForm() {
    return new Promise(function(resolve, reject) {
      form.schema
        .validate(form.data, { abortEarly: false })
        .then(values => {
          form.valid = true;
          form.errors = {};

          resolve(true);
        })
        .catch(validationErrors => {
          form.valid = false;
          form.errors = {};

          for (let i = 0; i < validationErrors.inner.length; i++) {
            let error = validationErrors.inner[i];
            form.errors[error.path] = {
              type: error.type,
              message:
                typeof error.errors[0] == "object"
                  ? error.errors[0].message
                  : error.errors[0]
            };
          }
        });
    });
  }

  async function passwordReset() {
    form.submitted = true;

    try {
      await ValidateForm(form);
      busy = true;
      await restActions.PasswordReset(hash, form.data.password);
      busy = false;

      setTimeout(() => {
        M.toast({ html: "Password has been reset" }, { displayLength: 3000 });
      }, 500);

      navigate("/");
    } catch (error) {
      busy = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, operatorId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        case "NonceExpired":
          myModal.showAlert(
            "Link expired",
            "Sorry, your password reset request has expired.<p>Please try again.</p>"
          );
          break;
        case "NonceInvalid":
          myModal.showAlert(
            "Link invalid",
            "Sorry, your password reset request is invalid.<p>If you are copying the link into your web browser please check it is complete and correct.</p>"
          );
          break;

        default:
          break;
      }
    }
  }

  function handleKeydown(event) {
    if (event.key == "Enter") passwordReset();
  }

  function ValidPassword(password) {
    if (password.length < 8) return false;

    let oneNumeric = /[0-9]/g;
    if (!oneNumeric.test(password)) return false;

    let oneUppercase = /[A-Z]/g;
    if (!oneUppercase.test(password)) return false;

    return true;
  }
</script>

<style>
  .helper-text {
    margin-bottom: 30px;
  }
</style>

<div class="container">

  <div class="row">
    <div class="col s12 m8 offset-m2 l6 offset-l3 xl4 offset-xl4">

      <img
      src="assets/logo.png"
      style="display: block; max-width: 100%; height: auto; margin: 40px auto 40px auto;"
      alt="" />

      <h5>Password reset</h5>

      <div class="input-field">
        <input type="password" bind:value={form.data.password} />
        <label>New password</label>
        {#if form.errors && form.errors.password}
          <div class="helper-text red-text">{form.errors.password.message}</div>
        {/if}
      </div>

      <div class="input-field">
        <input type="password" bind:value={form.data.repeatpassword} />
        <label>Repeat password</label>
        {#if form.errors && form.errors.repeatpassword}
          <div class="helper-text red-text">
            {form.errors.repeatpassword.message}
          </div>
        {/if}
      </div>

      <div
        style="display: flex; justify-content: space-between; align-items:
        center;">

        <a href="#!" on:click={() => navigate('/', { replace: true })}>
          Cancel
        </a>

        <button
          class="btn right wave-effect blue-grey"
          on:click={() => {
            passwordReset();
          }}
          disabled={busy}>
          Continue
        </button>
      </div>

    </div>

    {#if busy}
      <div
        style="display: flex; justify-content: center; align-items: center;
        height: 50px; width: 100%;">
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-green-only">
            <div class="circle-clipper left">
              <div class="circle" />
            </div>
            <div class="gap-patch">
              <div class="circle" />
            </div>
            <div class="circle-clipper right">
              <div class="circle" />
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>

</div>

<MyModal bind:this={myModal} />

<svelte:window on:keydown={handleKeydown} />
<RestActions bind:this={restActions} />
